import { Component, Vue } from 'vue-property-decorator';
import WithRender from './login.html';
import config from "@/settings/config.js";
import { IUserInfo, IUserProfile, UserClaim } from '@/Models/IUserInfo';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { userAuth } from '@/services/security';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading,
  }
})
export default class Login extends Vue {
  username: string = "";
  password: string = "";
  userInfo: IUserInfo = {} as IUserInfo;
  userProfile: IUserProfile = {} as IUserProfile;
  isLoading = false;
  toastMessage: string = "";

  async login() {
    this.isLoading = true;
    let dto = {
      UserName: this.username,
      Password: this.password
    }
    try {
      const response = await _axios.post(config.identity.authority + "/Login", dto)
      await this.userInfoSet(response.data);
      await this.getUserClaim();
      const redirect = (this.$route.query.redirect as string) || '/products';
      this.$router.push(redirect);
    } catch (error) {
      const err = error as any;
      if (err.response && err.response.status && err.response.status == '400')
        this.ErrorNotification(err.response.data, 'danger');
      else
      this.ErrorNotification("please check that you have data or your internet connection is on.", 'danger');
    } finally {
      this.isLoading = false;
    }
  }

  private async userInfoSet(value: IUserInfo) {
    this.userInfo = value;
    this.userInfo.username = this.username;
    this.userProfile.name = this.username;
    this.userInfo.profile = this.userProfile;
    this.userInfo.isManualLogin = true;
    await this.storeUserInfo();
  }

  private async storeUserInfo() {
    try {
      await this.$store.dispatch('login/setUser', this.userInfo);
    } catch (err) {
      console.error(err);
    }
  }

  async LoginGoogle() {
    this.isLoading = true;
    const redirect = (this.$route.query.redirect as string) || '/products';
    await userAuth.signIn(redirect);
  }

  private async getUserClaim() {
    try {
      const response = await _axios.get<UserClaim>(`${config.identity.authority}/connect/userinfo`);
      const claim = response.data;
      this.userInfo.profile.ReferralFirstLogin = claim.ReferralFirstLogin;
      await this.storeUserInfo();
    } catch (error) {
      console.error(error);
    }
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}